import { Button, ButtonStyles, Icons, ListItem, Tooltip } from '@silverfort/sf-components';
import React from 'react';
import { AD_ENTITY_TYPES, CONDITIONS_OPTIONS, CONDITIONS_OPTIONS_VALUE_LABEL } from '@silverfort-nodelibs/common/utils/consts';

const entitiesTypes = {
    [AD_ENTITY_TYPES.USER]: {
        tooltip: 'Account',
        icon: Icons.User
    },
    [AD_ENTITY_TYPES.GROUP]: {
        tooltip: 'Security group',
        icon: Icons.UserGroup
    },
    [AD_ENTITY_TYPES.OU]: {
        tooltip: 'Organizational unit',
        icon: Icons.Folder
    },
    [AD_ENTITY_TYPES.SERVER]: {
        tooltip: 'Server',
        icon: Icons.Server
    }
};

type CustomInsightsRowProps = {
    title: string;
    extraTitle?: string;
    subtitle?: string | undefined;
    IconLeft: React.FC<React.SVGProps<SVGSVGElement>>;
    selected?: boolean;
    onClick?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    disabled?: boolean;
};
const CustomInsightsRow: React.FC<CustomInsightsRowProps> = React.memo(
    ({ title, extraTitle, subtitle, IconLeft, selected, onClick, onEdit, onDelete, disabled }) => {
        return (
            <div
                className={`h-12 w-full rounded-lg items-center flex ${onClick ? 'hover:cursor-pointer' : ''} ${
                    selected ? 'bg-[#F5FAFF] border border-sf-primary-500' : 'hover:bg-sf-light-100'
                }`}
                onClick={onClick}>
                <div className={`w-28 ${extraTitle ? '' : 'flex-1'}`}>
                    <ListItem
                        title={title}
                        subtitle={subtitle}
                        IconLeft={IconLeft}
                        className={` bg-transparent hover:bg-transparent ${
                            onClick ? 'hover:cursor-pointer' : 'hover:cursor-default'
                        }`}
                        disabled={disabled}
                    />
                </div>
                {extraTitle && (
                    <div className="flex-1 items-center px-2">
                        <div className="h-6 px-2 items-center content-center rounded border border-sf-gray-100 w-fit text-sm font-normal">
                            {extraTitle}
                        </div>
                    </div>
                )}
                {!disabled && (
                    <div onClick={(e) => e.stopPropagation()} className="flex px-2 items-center">
                        {onEdit && (
                            <Tooltip title="Edit">
                                <Button
                                    iconLeft={Icons.Edit}
                                    onClick={onEdit}
                                    iconSize={16}
                                    buttonStyle={ButtonStyles.GhostSolid}
                                    className="bg-transparent"
                                />
                            </Tooltip>
                        )}
                        <Tooltip title="Remove">
                            <Button
                                iconLeft={Icons.Cancel}
                                onClick={onDelete}
                                iconSize={16}
                                buttonStyle={ButtonStyles.GhostSolid}
                                className="bg-transparent"
                            />
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    }
);

export const EntityRow = ({ type, name, domainName, ...resourceRowProps }) => {
    return (
        <CustomInsightsRow
            title={name}
            subtitle={domainName ? `(${domainName})` : undefined}
            IconLeft={entitiesTypes[type].icon}
            {...resourceRowProps}
        />
    );
};

export const ConditionRow = ({ condition, ...resourceRowProps }) => {
    const typesIcons = {
        [CONDITIONS_OPTIONS.START_WITH.value]: Icons.TextStart,
        [CONDITIONS_OPTIONS.END_WITH.value]: Icons.TextEnd,
        [CONDITIONS_OPTIONS.CONTAINS.value]: Icons.TextContains
    };

    return (
        <CustomInsightsRow
            title={CONDITIONS_OPTIONS_VALUE_LABEL[condition.conditionType]}
            extraTitle={condition.conditionString}
            IconLeft={typesIcons[condition.conditionType]}
            {...resourceRowProps}
        />
    );
};
